import * as React from "react";
import * as styles from "./styles.scss";
import { darken, lighten, makeStyles } from "@material-ui/core/styles";
import { themeVariables } from "../../../MUI";
import { SmallCross } from "../../../../../components/Icons/smallCross";

const useStyles = makeStyles((theme) => ({
  tag: {
    display: 'box',
    fallbacks: {
      display: '-webkit-box',
    },
    boxOrient: 'vertical',
    lineClamp: 1,
    "-webkit-line-clamp": 1,
    maxWidth: (props: {color?: string, fullWidth?: boolean}) => props.fullWidth ? 'auto' : 135,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    alignItems: 'center',
    padding: '1px 4px',
    fontSize: 13,
    minWidth: 16,
    lineHeight: '16px',
    font: 'SF UI Text',
    letterSpacing: '0.26px',
    wordBreak: 'break-all',
  },
  root: {
    maxWidth: (props: {color?: string, fullWidth?: boolean}) => props.fullWidth ? 'auto' : 145,
    color: (props: {color?: string, fullWidth?: boolean}) => props.color ? darken(props.color, .3) : darken(theme.palette.primary.main, .3),
    background: (props: {color?: string, fullWidth?: boolean}) => props.color ? lighten(props.color, 0.8)  : lighten(theme.palette.primary.main, 0.8),
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    maxHeight: 18,
    borderRadius: '2px',
    cursor: 'pointer',
  },
  smallCrossIcon: {
    fontSize: 10,
    marginLeft: 4,
    paddingRight: 4,
    color: (props: {color?: string, fullWidth?: boolean}) => props.color ? props.color : theme.palette.primary.main,
    cursor: 'pointer',

  }
}))

export default React.forwardRef<HTMLSpanElement, { children?: any, color?: string, onCancel?: () => void, fullWidth?: boolean } & React.HTMLAttributes<HTMLSpanElement>>((props, ref) => {
  const classes = useStyles({color: props.color, fullWidth: props.fullWidth})
  return (
    <div className={classes.root} title={props.children}>
      <span ref={ref} className={`${classes.tag} ${props.className}`}>{props.children} </span>
      {props.onCancel && <SmallCross onClick={props.onCancel} className={classes.smallCrossIcon} />}
    </div>
  );
});
